import PropTypes from "prop-types";

import MainInfoSection from "./MainInfoSection";
import OverviewSection from "./OverviewSection";
import VideoSection from "./VideoSection";
import KeywordsSection from "./KeywordsSection";
import { ATTACHMENTS_TYPES } from "../../../../utils/Constants";
import "./ViewProduct.scss";

const ViewProduct = ({ productDetails }) => {
  return (
    <div className="product-details-container">
      {productDetails && !!Object.keys(productDetails).length && (
        <>
          <MainInfoSection productDetails={productDetails} />
          {(productDetails?.Description ||
            productDetails?.Specifications) && (
            <OverviewSection
              description={productDetails?.Description}
              specifications={productDetails?.Specifications}
            />
          )}
          {!!productDetails?.Attachments?.filter(
            (attachment) =>
              attachment?.AttachmentTypeId === ATTACHMENTS_TYPES.video
          )?.length && (
            <VideoSection
              videoSrc={
                productDetails?.Attachments?.filter(
                  (attachment) =>
                    attachment?.AttachmentTypeId ===
                    ATTACHMENTS_TYPES.video
                )[0]?.MediaName
              }
              videoName={
                productDetails?.Attachments?.filter(
                  (attachment) =>
                    attachment?.AttachmentTypeId ===
                    ATTACHMENTS_TYPES.video
                )[0]?.OriginalMediaName
              }
            />
          )}
          {productDetails?.Keywords &&
            !!productDetails?.Keywords.length && (
              <KeywordsSection
                keywords={productDetails?.Keywords?.map(
                  (keyword) => keyword?.Name
                )}
              />
            )}
        </>
      )}
    </div>
  );
};

export default ViewProduct;

ViewProduct.propTypes = {
  productDetails: PropTypes.object
};
